import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-mail-icon lucide-mail",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }), /* @__PURE__ */ _jsx("rect", {
		x: 2,
		y: 4,
		width: 20,
		height: 16,
		rx: 2
	})]
});
export default SvgMail;
